import Tasks from 'APP/Tasks';
import bus from 'APP/packages/bus';
import Entities from 'STORE';
import { ChatMessage } from 'STORE/Messages/Message/ChatMessage/ChatMessage';

export const startReplyMessage = async (message: ChatMessage): Promise<void> => {
  if (!message) {
    return;
  }

  const inputPanel = Entities.InputPanelsStore.activeInputPanel;
  const activeGroup = Entities.GroupsStore.activeGroup;

  if (!inputPanel || !activeGroup) {
    return;
  }

  // You can't make quotes in public if you're not admin
  if (activeGroup.isChannel && !activeGroup.withMeInAdmins) {
    return;
  }

  if (inputPanel.editMessage) {
    const isEndEditMessageSuccess = await Tasks.messaging.endEditMessage(activeGroup.id);

    if (!isEndEditMessageSuccess) {
      return;
    }
  }
  inputPanel.setReplyMessage(message);
  bus.messaging.broadcastStartReplyMessage();
};
